import type { ButtonHTMLAttributes, ReactNode } from 'react';
import styles from './IconButton.module.css';

export interface IconButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  /** Accessible label — required since the button is icon-only. */
  label: string;
  size?: 'sm' | 'md' | 'lg';
  active?: boolean;
  children: ReactNode;
}

export function IconButton({
  label,
  size = 'md',
  active = false,
  className,
  children,
  type = 'button',
  ...rest
}: IconButtonProps) {
  const classes = [styles.iconBtn, styles[size], active ? styles.active : undefined, className]
    .filter(Boolean)
    .join(' ');
  return (
    <button type={type} className={classes} aria-label={label} title={label} {...rest}>
      <span aria-hidden>{children}</span>
    </button>
  );
}
